 
import { z } from 'zod'
import { locale, slug } from '../other'

const slugWithLocaleSchema = z.object({
  locale,
  slug,
})

export default slugWithLocaleSchema
